(function () {
  'use strict';

  if (window.__egSelleasyCompatInstalled) return;
  window.__egSelleasyCompatInstalled = true;

  function patchSelleasy() {
    var utils = window.lbSelleasyUtils;
    if (!utils || utils.__egCompleteArrayGuard) return Boolean(utils);

    if (typeof utils.getProducts === 'function') {
      var nativeGetProducts = utils.getProducts;
      utils.getProducts = function (productIds) {
        if (!Array.isArray(productIds)) return Promise.resolve();
        return nativeGetProducts.apply(this, arguments);
      };
    }

    if (typeof utils.productReviews === 'function') {
      var nativeProductReviews = utils.productReviews;
      utils.productReviews = function (widget, config) {
        var reviews = config && config.integrations &&
          config.integrations.topics && config.integrations.topics.reviews;
        var offers = widget && widget.lbPayload && widget.lbPayload.widget &&
          widget.lbPayload.widget.offers;

        if (reviews && reviews.isEnabled && !Array.isArray(offers)) {
          return Promise.resolve();
        }

        return nativeProductReviews.apply(this, arguments);
      };
    }

    utils.__egCompleteArrayGuard = true;
    return true;
  }

  document.addEventListener('lb-utils-init', patchSelleasy);

  if (!patchSelleasy()) {
    var attempts = 0;
    var patchTimer = window.setInterval(function () {
      attempts += 1;
      if (patchSelleasy() || attempts >= 100) window.clearInterval(patchTimer);
    }, 100);
  }
})();
